export const l5eRykerData = {
  path: '/l5e-ryker',
  breadcrumb: [
    ['Formations 2 & 3 roues', '/formation'],
    ['L5e (3-roues / Ryker)', '/l5e-ryker'],
  ],
  kicker: 'Catégorie L5e · 3-roues motorisé',
  title: '3-roues / Ryker',
  titleHighlight: 'la catégorie L5e.',
  subtitle:
    "Can-Am Ryker, Spyder, Piaggio MP3, Yamaha Tricity 300... Quel permis pour conduire un 3-roues motorisé (catégorie L5e) ? Le guide complet ECSR.",
  seoTitle: '3-roues L5e (Ryker, Spyder, MP3) — Quel permis ? Le guide complet',
  seoDescription:
    "Conduire un 3-roues motorisé (Ryker, Spyder, Piaggio MP3) avec quel permis ? Catégorie L5e : conditions, formations, équivalences, conseils. Le guide ECSR 2026.",
  seoKeywords:
    'permis 3 roues, can am ryker permis, can am spyder permis, piaggio mp3 permis, yamaha tricity permis, catégorie l5e, 3 roues permis b, 3 roues sans permis moto',
  heroImage:
    'https://images.unsplash.com/photo-1599819811279-d5ad9cccf838?w=2400&q=85&auto=format&fit=crop',
  heroImageAlt: 'Can-Am Ryker 3-roues sur route',
  duration: 'Variable selon le modèle',
  cost: '7h obligatoire ou permis A1/A2 selon modèle',
  timeRequired: 'PT7H',
  about: 'Catégorie L5e, 3-roues motorisé, Can-Am Ryker, Piaggio MP3',
  primaryCta: { label: 'Voir les formations', to: '/formation' },
  secondaryCta: { label: 'Permis A1 / A2', to: '/permis-a1-a2' },
  relatedTopic: 'l5e-ryker',
  accentColor: '#7c3aed',

  intro:
    "<p>La <strong>catégorie L5e</strong> regroupe tous les <strong>tricycles motorisés</strong> (3-roues) dont la cylindrée dépasse 50 cm³ et la puissance dépasse 4 kW. Cela inclut les <strong>Can-Am Ryker</strong>, <strong>Spyder</strong>, <strong>Piaggio MP3 300+</strong>, <strong>Yamaha Tricity 300</strong>, et autres trikes.</p><p>Le permis requis dépend de la <strong>configuration des roues</strong> et de la <strong>puissance</strong>. Bonne nouvelle : pour la plupart des 3-roues ≤ 15 kW, le <strong>permis B</strong> avec la <strong>formation 7h</strong> suffit. Pour les plus puissants, c'est le permis A1 ou A2 qui s'impose. Le guide complet ci-dessous.</p>",

  conditions: [
    {
      title: 'Permis B + 7h (la majorité des cas)',
      text: 'Pour les 3-roues L5e jusqu\'à 15 kW (20 ch) : permis B ≥ 2 ans + formation 7h en moto-école. Couvre Ryker, MP3 300, Tricity 300, etc.',
    },
    {
      title: 'Permis A1 (16 ans+)',
      text: 'Pour les 3-roues L5e jusqu\'à 15 kW : le permis A1 fonctionne aussi. Pratique pour les jeunes conducteurs sans permis B.',
    },
    {
      title: 'Permis A2 (18 ans+)',
      text: 'Pour les 3-roues L5e plus puissants (15-35 kW). Un Spyder F3-T (74 kW) nécessite le permis A complet (ou un Ryker 900 ≤ 60 kW → A2 bridé).',
    },
    {
      title: 'Permis A (après passerelle)',
      text: 'Pour les 3-roues L5e > 35 kW (Spyder F3-T, RT, etc.). Le permis A complet (après passerelle A2 → A) couvre tous les cas.',
    },
  ],

  steps: [
    {
      title: 'Vérifier la fiche technique du véhicule',
      duration: '5 minutes',
      text: 'Carte grise > champ J = L5e. Champ P.2 = puissance en kW. Si P.2 ≤ 15 kW → permis B + 7h. Sinon, vois les options A1/A2/A.',
    },
    {
      title: 'Faire la formation 7h (si permis B)',
      duration: '7 heures',
      text: 'Même formation que pour les 125 cm³ (catégorie L3e). Théorique 1h + maniabilité 3h + circulation 3h. Tarif : 230-350 €.',
    },
    {
      title: 'Prendre en main le 3-roues',
      duration: '1-3 sorties',
      text: 'Le pilotage d\'un 3-roues est TRÈS différent d\'une moto 2-roues : pas d\'inclinaison, contre-virage inutile, comportement plus proche d\'un kart. Demande au concessionnaire ou à ta moto-école un essai prolongé.',
    },
    {
      title: 'Équipement obligatoire',
      duration: 'Permanent',
      text: 'Même réglementation que pour la moto 2-roues : casque ECE 22-06, gants CE, vêtements adaptés, chaussures montantes. Pas de dérogation pour les 3-roues.',
    },
  ],

  erreurs: [
    {
      title: 'Croire qu\'un 3-roues = pas besoin de formation',
      text: 'Faux. Même avec 3 roues, c\'est un véhicule motorisé de catégorie L5e. La formation 7h est OBLIGATOIRE depuis 2011 si tu as le permis B.',
    },
    {
      title: 'Sous-estimer la différence avec une moto',
      text: "Un 3-roues ne s'incline PAS (sauf MP3 et Tricity). Le pilotage est totalement différent : pas de contre-virage, freinage avec frein à main + pédale (selon modèle).",
    },
    {
      title: 'Oublier l\'équipement complet',
      text: 'Même en Spyder fermé (style auto), gants + casque obligatoires en France. Pas d\'équivalence \"voiture\" pour les L5e.',
    },
    {
      title: 'Confondre L5e et L7e',
      text: 'L7e = quadricycle lourd (voiture sans permis). L5e = 3-roues motorisé. Réglementations TRÈS différentes ! Les voitures sans permis se conduisent avec le permis AM ou B selon les cas.',
    },
  ],

  conseils: [
    'Avant achat : essayer plusieurs modèles (Ryker, Spyder, MP3) — ils ont des comportements très différents.',
    'Le Can-Am Ryker est idéal pour débuter : direct, intuitif, \"sécuritaire\". Le Spyder demande plus d\'expérience.',
    "Pour les MP3 et Tricity 300 : ils s'inclinent comme une moto, c'est la transition la plus douce depuis le scooter classique.",
    'Vérifie la mention \"L5e\" sur la carte grise avant achat : c\'est ce qui détermine le permis requis.',
    'Conserve l\'attestation 7h en permanence sur toi en cas de contrôle.',
  ],

  faq: [
    {
      q: 'Quel permis pour conduire un Can-Am Ryker ?',
      a: 'Le Can-Am Ryker (catégorie L5e, ~ 64 ch / 47 kW) nécessite le permis A2 minimum (18 ans+, bridé à 35 kW) ou le permis A complet après passerelle. Le Ryker 600 (50 ch / 37 kW) est compatible A2.',
    },
    {
      q: 'Quel permis pour conduire un Piaggio MP3 ?',
      a: 'Dépend de la cylindrée : MP3 300 (≤ 15 kW) = permis B + 7h ou A1. MP3 500 / 530 (40 kW) = permis A2 ou A. La carte grise (champ P.2) donne la puissance officielle.',
    },
    {
      q: 'Faut-il un casque sur un 3-roues type Spyder ?',
      a: 'OUI, casque obligatoire en France pour TOUS les véhicules de catégorie L (L1e à L7e). Pas d\'exception pour les Can-Am Ryker / Spyder ou autres trikes. Sanctions : 135 € + retrait 3 points.',
    },
    {
      q: 'Le permis B suffit-il pour un 3-roues ?',
      a: 'Non, pas tout seul. Pour conduire un 3-roues L5e avec un permis B, tu dois OBLIGATOIREMENT avoir suivi la formation 7h en moto-école (même formation que pour les 125 cm³). Sans cette attestation, c\'est interdit.',
    },
    {
      q: 'Différence entre L5e (3-roues) et L7e (voiturette) ?',
      a: 'L5e = tricycle motorisé ouvert (Ryker, MP3, Tricity 300...). L7e = quadricycle lourd type voiturette (Aixam, Ligier, Microcar...). Les L7e se conduisent avec le permis AM ou B selon poids. Réglementations distinctes.',
    },
    {
      q: 'Peut-on conduire un Yamaha Tricity 125 sans permis A1 ?',
      a: 'Le Tricity 125 (≤ 11 kW, catégorie L5e) est conduisible avec le permis B + formation 7h. Tu peux aussi le conduire avec le permis A1 (16 ans+). Même véhicule, plusieurs voies possibles.',
    },
  ],

  sourceLabel:
    'Règlement UE 168/2013 (catégories L), Code de la route articles R311-1 et suivants, Sécurité routière.',
  sourceUrl: 'https://www.service-public.fr/particuliers/vosdroits/F2814',
};
